module.exports = function() {
  return new Worker(__webpack_public_path__ + "aa2bd59a15565095b905.worker.js");
};